import React, {PropTypes, Component} from "react";
import {inject, observer} from "mobx-react";
import {Button, Col, FormGroup, Input, Label, Row} from 'reactstrap';
import FontAwesome from 'react-fontawesome';
import DatePicker from 'react-datepicker';
import DataWrapper from "../../principal/containers/DataWrapper";
import SolicitacaoContratacaoStore from "../stores/SolicitacaoContratacaoStore";
import ParametrosGeraisStore from "../../administracao/stores/ParametrosGeraisStore";
import Select from "react-select";
import {arrayToString, createSelectOptions, formatarReal, formatTelefone, getByAtribute} from "../../../utils/formatar";
import InputMask from 'react-input-mask';
import {motivoContratacaoEnum, tiposEmailContratacaoEnum} from "../../../utils/enums";
import NumberFormat from "react-number-format";
import {Validacao} from "../../comum/components/Validacao";
import _ from 'lodash';
import {Link, Redirect} from 'react-router-dom';
import {ModalForm} from "../../comum/components/ModalForm";
import {toast} from "react-toastify";
import {SolicitanteForm} from "../components/SolicitanteForm";
import {ContatoForm} from "../components/ContatoForm";
import {EmpregadosSubstituidosForm} from "../components/EmpregadosSubstituidosForm";
import {CargoForm} from "../components/CargoForm";
import {IndicacoesForm} from "../components/IndicacoesForm";
import {JustificativaExcecaoForm} from "../components/JustificativaExcecaoForm";
import {DetalhamentoHistoricoFluxo} from "../../fluxos/comum/components/DetalhamentoHistoricoFluxo";
import moment from "moment";
import loading from '../../../assets/images/ajax-loader.gif';
import {DebitoForm} from "../components/DebitoForm";
import {LoadingPanel} from "../../comum/components/LoadingPanel";
import {FormErrors} from "../../comum/components/FormErrors";
import FormErrorsStore from "../../comum/stores/FormErrorsStore";
import { TooltipIcon } from "../../comum/components/TooltipIcon";
import axios from "axios";

@inject("store")
@DataWrapper
@observer
export class SolicitacaoContratacao extends Component {
    constructor(props) {
        super(props);
        this.loginStore = this.props.store.loginStore;
        this.formStore = this.props.store.formStore;
        this.tituloPaginaStore = this.props.store.tituloPaginaStore;
        this.validacaoStore = this.props.store.validacaoStore;
        this.modalStore = this.props.store.modalStore;
        this.loadingPanelStore = this.props.store.loadingPanelStore;
        this.solicitando = false;
        this.parametrosGeraisStore = new ParametrosGeraisStore();
        this.formErrorsStore = new FormErrorsStore();
        this.controller = new SolicitacaoContratacaoStore(this.loginStore, this.modalStore, this.formStore, this.validacaoStore, this.tituloPaginaStore, this.loadingPanelStore, this.formErrorsStore);

        this.enviar = this.enviar.bind(this);
        this.salvarRascunho = this.salvarRascunho.bind(this);

    }

    componentDidMount() {
        this.tituloPaginaStore.setTitulo("Nova solicitação de contratação");
        this.controller.setTitulo(_.get(this.props, "match.path"))

        this.controller.carregarLista(_.get(this.props, "match.params.id"), _.get(this.props, "match.path"));
        this.parametrosGeraisStore.carregarLista();
    }

    observacoesModal() {
        const aprovadoresExtraForm = [];
        if (this.controller.solicitacao.optionAprovadoresExtra) {
            for (let i = 0; i < this.controller.solicitacao.optionAprovadoresExtra.length; i++) {
                aprovadoresExtraForm.push(<Row key={i}>
                    <Col xs={12}>
                        {this.controller.solicitacao.optionAprovadoresExtra[i] !== null &&
                        <FormGroup>
                            <div className="multiple-selects">
                                <Select className="multiple-selects-input"
                                        options={this.controller.todosAprovadores}
                                        value={this.controller.solicitacao.optionAprovadoresExtra[i]}
                                        onChange={(value, option) => {
                                            this.controller.setMatriculaAprovadoresExtra(value, option, i)
                                        }}
                                        asyncOptions={ (input, callback) => {this.controller.filtrarAprovadoresExtra(input,callback);}}
                                        multi={false}
                                        placeholder="Selecione..."
                                        noResultsText="Nenhum resultado encontrado"
                                />
                                <div className="multiple-selects-buttons">
                                    {(i > this.controller.posicaoPrimeiroAprovadorExtra || this.controller.quantidadeAprovadoresExtraMostrados > 1) &&
                                    <a onClick={() => this.controller.removerAprovadorExtra(i)}
                                       title="Remover"><FontAwesome name="minus-circle"/></a>}
                                    <a onClick={() => this.controller.adicionarAprovadorExtra(i)}
                                       title="Adicionar"><FontAwesome name="plus-circle"/></a>
                                </div>
                            </div>
                        </FormGroup>
                        }
                    </Col>
                </Row>)
            }
        }
        return (
            <div>
                {_.get(this.modalStore, "exibirModal.tipo") === 'cancelar' ? (
                    <FormGroup>
                        <Label>Observações <sup>*</sup></Label>
                        <Input type="textarea" maxLength={1024} value={this.controller.observacoes}
                               onChange={(event) => this.controller.setObservacoes(event.target.value)}/>
                        <Validacao id="observacoes" valor={this.controller.observacoes} tipo={["isRequired"]}/>
                    </FormGroup>
                ) : _.get(this.controller, "solicitacao.usuarioSolicitante.matricula", "-1") == _.get(this.controller, "solicitacao.gestorSolicitante.matricula", "-2") && !_.get(this.controller.solicitacao, "solicitacaoExcecao") ? (
                    <div>
                        {this.controller.quantidadeAprovadoresExtraMostrados > 0 && <Label>Aprovadores extra</Label>}
                        {aprovadoresExtraForm}
                        <FormGroup>
                            <Validacao id="aprovadoresUnicos"
                                       valor={this.controller.apenasMatriculaAprovadoresExtraValidos}
                                       tipo={["isArrayUnique"]}/>
                        </FormGroup>
                    </div>
                ) : this.controller.isSolicitacaoDeAjuste ? (
                    <FormGroup>
                        <Label>Observações</Label>
                        <Input type="textarea" maxLength={1024} value={this.controller.observacoes}
                               onChange={(event) => this.controller.setObservacoes(event.target.value)}/>
                    </FormGroup>
                ) : (
                    <span>Confirma a solicitação de contratação?</span>
                )}

            </div>
        )
    }

    botoesModalEnviar() {
        return (<div>

            <Button color="primary" onClick={this.enviar} disabled={this.modalStore.loading}>Confirmar</Button>
            <Button color="secondary" onClick={() => this.modalStore.toggleModal()}
                    disabled={this.modalStore.loading}>Cancelar</Button>
        </div>)
    }

    botoesModalCancelar() {
        return (<div>
            <Button color="primary" onClick={this.cancelar} disabled={this.modalStore.loading}>Confirmar</Button>
            <Button color="secondary" onClick={() => this.modalStore.toggleModal()}
                    disabled={this.modalStore.loading}>Cancelar</Button>
        </div>)
    }

    modalForm() {
        if (this.modalStore.exibirModal.aberto) {
            switch (this.modalStore.exibirModal.tipo) {
                case 'enviar':
                    return (
                        <ModalForm
                            corpo={this.observacoesModal()}
                            cabecalho={"Solicitação" + ": Enviar"}
                            botoes={this.botoesModalEnviar()}/>
                    );
                case 'cancelar':
                    return (
                        <ModalForm
                            corpo={this.observacoesModal()}
                            cabecalho={"Solicitação" + ": Cancelar"}
                            botoes={this.botoesModalCancelar()}/>
                    );
            }
        }
    }

    static propTypes = {
        label: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.array,
            PropTypes.object,
        ])
    };

    voltar() {
        window.history.back();
    }

    actionToolBar() {
        return (
            <Row>
                <Col xs={12} md={4}>
                    {this.controller.solicitacao.id ? (
                        <h4 className="align-top">Solicitação: {this.controller.solicitacao.id}</h4>
                    ) : ""}
                </Col>
                <Col xs={12} md={8}>
                    <div className="form-buttons">
                        <Button onClick={() => this.voltar()}>Voltar</Button>{' '}
                        {/*<Link to="/solicitacoes-pendentes" className="btn btn-secondary">Voltar</Link>{' '}*/}
                        {this.controller.isSolicitacaoDeAjuste ?
                            <Button color="danger"
                                    onClick={() => this.controller.openModal('cancelar', false)}>Cancelar</Button> :
                            <Button disabled={(!this.controller.habilitarSalvarRascunho) || (this.controller.carregandoCargo || (this.controller.loadingCpfIndicacao && this.controller.loadingCpfIndicacao.length > 0))}
                                    onClick={() => this.salvarRascunho()}>Salvar rascunho</Button>}{' '}
                        <Button color="primary" disabled={this.controller.carregandoCargo || (this.controller.loadingCpfIndicacao && this.controller.loadingCpfIndicacao.length > 0)} onClick={() => this.controller.openModal('enviar')}>Enviar</Button>
                    </div>
                </Col>
            </Row>);
    }

    error() {
        return (
            <Row>
                <Col xs={12} md={12}>
                    <br/>
                    <div className="form-buttons">
                        <span style={{color: 'red'}}>Existem dados inválidos no formulário. Favor corrigi-los antes de prosseguir.</span>
                    </div>
                </Col>
            </Row>);
    }

    enviar = () => this.executarETratarResultado(this.controller.enviar, 'enviada');

    cancelar = () => this.executarETratarResultado(this.controller.cancelar, 'cancelada!', () => {return this.validacaoStore.isValid(['observacoes'])});

    defaultValidation = () => {return this.validacaoStore.isValidForm && !this.modalStore.loading};

    executarETratarResultado = (funcaoExecutar, mensagemSucesso, validation = this.defaultValidation) => {
        this.modalStore.setSubmitted(true);
        this.modalStore.setSubmitMensagemErro("");
        if (this.controller.solicitacao.solicitacaoExcecao) {
            this.controller.solicitacao.quantidadeRecursos = 1;
        }
        if (validation()) {
            this.modalStore.loading = true;
            funcaoExecutar().then(response => {
                if (mensagemSucesso === 'enviada') {
                    if (this.controller.solicitacao.id > 0) {
                        toast.success(`Solicitação ${mensagemSucesso}`);
                    } else {
                        this.controller.solicitacao.id = response.data.id;
                        toast.success(`Solicitação ${this.controller.solicitacao.id} ${mensagemSucesso}`, {autoClose: false});
                    }
                } else {
                    toast.success(`Solicitação ${mensagemSucesso}`);
                }
                this.modalStore.toggleModal();
                this.formStore.toggleAcaoEnviada();
            }).catch(error => {
                this.modalStore.setSubmitMensagemErro(error.response.data.message);
                this.modalStore.loading = false;
            });

        }
    };


    salvarRascunho() {

        const options = {
            onOpen: props => this.controller.habilitarSalvarRascunho = false,
            onClose: props => this.controller.habilitarSalvarRascunho = true
        }

        if (!this.solicitando) {
            this.solicitando = true;
            this.controller.salvarRascunho().then(response => {
                this.controller.solicitacao.id = response.data.id;
                this.solicitando = false;
                toast.success(`Rascunho salvo com sucesso.`, options);
            }).catch(error => {
                this.solicitando = false;
                if(_.get(error, "response.data.message")) {
                    if(axios.isCancel(error) ){
                        toast.error('Operação de salvar rascunho cancelada.');
                    } else {
                        toast.error(error.response.data.message, options);
                    }
                }
            });
        }
    }

    render() {
        if (this.formStore.acaoEnviada) {
            return <Redirect to="/solicitacoes-pendentes"/>;
        } else {
            return this.renderForm();
        }
    }

    renderForm() {
        const justificativaContratacaoOptions = createSelectOptions(this.controller.justificativasContratacao, "id", "nome");
        const localTrabalhoOptions = this.controller.locaisTrabalho;
        const lotacaoOptions = createSelectOptions(this.controller.lotacoes, "id", "nome")
        const motivoContratacaoOptions = createSelectOptions(motivoContratacaoEnum, "id", "valor");
        const produtoOptions = this.controller.produtos.map(produto => {
            return { value: produto.id, label: produto.codigo + " - " + produto.nome }
        });
        const fatoGeradorOptions = this.controller.fatosGeradores.map(produto => {
            return {value: produto.id, label: produto.nome + ' (' + produto.codigo + ')'}
        });
        const gestorOptions = createSelectOptions(_.get(this.loginStore, "usuarioLogado.gestores"), "cpf", "nome");
        const dataInicio = _.get(this.controller, "solicitacao.momentDataInicio");
        const momentDataInicio = _.get(this.controller, "solicitacao.momentDataInicio", null);
        let curtoIniSolicDiasMin = _.get(this.controller.solicitacao, "justificativaContratacao.curtoIniSolicDiasMin");
        let curtoIniSolicDiasMax = _.get(this.controller.solicitacao, "justificativaContratacao.curtoIniSolicDiasMax");
        const solicContratacaoDiasMax = _.get(this.controller.solicitacao, "justificativaContratacao.solicContratacaoDiasMax");
        const solicContratacaoDiasMin = _.get(this.controller.solicitacao, "justificativaContratacao.solicContratacaoDiasMin");
        const hoje = moment().format('DD/MM/YYYY');
        const gestoresAreaDebitoOptions = createSelectOptions(this.controller.gestoresArDebito, "matricula", "nome")
        const minDate = curtoIniSolicDiasMin ? moment().add(curtoIniSolicDiasMin, "days") : moment()

        const isJustificativaCusteioDireto = this.controller.isJustificativaCusteioDireto;
        const isCentroCustoDebitoMediaPulse = this.controller.isCentroCustoDebitoMediaPulse;
        const bloqueioJustificativaCusteioDireto = isJustificativaCusteioDireto && !isCentroCustoDebitoMediaPulse;
    
        //RHFPP-1020
        const tipoEmailContratacaoOptions = createSelectOptions(tiposEmailContratacaoEnum, "id", "valor");
        const textoTipoEmailContratacao = this.controller.tipoEmailContratacao != null
            ? _.get(getByAtribute(tiposEmailContratacaoEnum, this.controller.tipoEmailContratacao, "id"), "descricao", "")
            : "";
            
        if (curtoIniSolicDiasMin < 0 || curtoIniSolicDiasMin == undefined)
            curtoIniSolicDiasMin = this.parametrosGeraisStore.parametros.pmrifSolicitacaoMin;
        if (curtoIniSolicDiasMax < 0 || curtoIniSolicDiasMax == undefined) {
            curtoIniSolicDiasMax = this.parametrosGeraisStore.parametros.pmrifSolicitacaoRgl;
        }

        let msgPrazoRegulamentado = ''
        if (this.controller.solicitacao.momentDataInicio) {
            const diasDeHoje = moment(this.controller.solicitacao.momentDataInicio, 'DD-MM-YYYY').diff(moment(hoje, 'DD-MM-YYYY'), 'days')
            if (diasDeHoje < curtoIniSolicDiasMax)
                msgPrazoRegulamentado =
                    <span style={{color: 'darkorange', display: 'block'}}>O prazo para início é inferior ao regulamentado, seus indicadores serão afetados</span>
        }

        return (
            <div>
                <div className="form-wrapper">
                    <LoadingPanel>
                        <div className="content-panel panel-sm">
                            <div className="panel-form">
                                <FormErrors controller={this.formErrorsStore} />
                                {this.actionToolBar()}
                                {this.formStore.submitted && !this.modalStore.exibirModal.aberto && !this.validacaoStore.isValidForm ? this.error() : ''}
                                {this.controller.exibeJustificativaExcecao &&
                                <JustificativaExcecaoForm controller={this.controller}/>
                                }
                                <SolicitanteForm
                                    gestorSolicitante={this.controller.solicitacao.gestorSolicitante}
                                    usuarioSolicitante={this.controller.solicitacao.usuarioSolicitante}
                                    controller={this.controller}
                                />
                                <ContatoForm
                                    contatoGlobo={this.controller.solicitacao.contatoGlobo}
                                    setTelefone={(...props) => this.controller.setContatoGloboTelefone(...props)}
                                    setNome={(...props) => this.controller.setContatoGloboNome(...props)}
                                    setEmail={(...props) => this.controller.setContatoGloboEmail(...props)}
                                />
                                <h4>Locais</h4>
                                <Row>
                                    <Col xs={12} md={6} lg={4}>
                                        <FormGroup>
                                            <Label>Previsão trabalho externo <sup>*</sup></Label>
                                            <Input type="select"
                                                   value={this.controller.solicitacao.previsaoTrabalhoExterno}
                                                   onChange={(event) => this.controller.setPrevisaoTrabalhoExterno(event.target.value === "true")}>
                                                <option value={"true"}>Sim</option>
                                                <option value={"false"}>Não</option>
                                            </Input>
                                        </FormGroup>
                                    </Col>
                                    <Col xs={12} md={6} lg={4}>
                                        <FormGroup>
                                            <Label>Lotação <sup>*</sup></Label>
                                            <Select placeholder="Selecione..."
                                                    options={lotacaoOptions}
                                                    value={this.controller.solicitacao.lotacaoId}
                                                    noResultsText="Nenhum resultado encontrado"
                                                    onChange={(value) => this.controller.setLotacao(value)}
                                            />
                                            <Validacao id="lotacaoId"
                                                       valor={this.controller.solicitacao.lotacaoId}
                                                       tipo={["isRequired"]}/>
                                        </FormGroup>
                                    </Col>
                                    <Col xs={12} md={6} lg={4}>
                                        <FormGroup>
                                            <Label>Local de trabalho <sup>*</sup></Label>
                                            <Select value={this.controller.solicitacao.localTrabalho}
                                                    valueKey={"id"}
                                                    labelKey={"template"}
                                                    options={localTrabalhoOptions}
                                                    onChange={(value, options) => this.controller.setLocalTrabalho(value, options)}
                                                    noResultsText="Nenhum resultado encontrado" placeholder="Selecione..."
                                                     />
                                            <Validacao id="localTrabalhoId" valor={_.get(this.controller.solicitacao.localTrabalho, "codigo")}
                                                       tipo={["isRequired"]}/>
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <DebitoForm controller={this.controller}/>
                                <h4>Justificativa</h4>
                                <Row>
                                    <Col xs={12} md={6} lg={4}>
                                        <FormGroup>
                                            <Label>Motivo de contratação <sup>*</sup></Label>
                                            <Select value={this.controller.solicitacao.motivoContratacao}
                                                    options={motivoContratacaoOptions}
                                                    onChange={(value) => this.controller.setMotivoContratacao(value)}
                                                    noResultsText="Nenhum resultado encontrado"
                                                    placeholder="Selecione..."
                                                    multi={false}/>
                                            <Validacao id="motivo"
                                                       valor={this.controller.solicitacao.motivoContratacao}
                                                       tipo={["isRequired"]}/>
                                        </FormGroup>
                                    </Col>
                                    <Col xs={12} md={6} lg={4}>
                                        <FormGroup>
                                            <Label>Justificativa/alocação <sup>*</sup> {/*<FontAwesome name="question-circle" />*/}
                                            </Label>
                                            <Select value={this.controller.solicitacao.justificativaContratacaoId}
                                                    disabled={justificativaContratacaoOptions.length === 0 || !this.controller.solicitacao.motivoContratacao}
                                                    options={justificativaContratacaoOptions}
                                                    onChange={(value) => this.controller.setJustificativaContratacao(value)}
                                                    noResultsText="Nenhum resultado encontrado"
                                                    placeholder="Selecione..."
                                                    multi={false}/>
                                            <Validacao id="justificativaContratacaoId"
                                                       valor={this.controller.solicitacao.justificativaContratacaoId}
                                                       tipo={["isRequired", 
                                                        "justificativaCusteioDireto", bloqueioJustificativaCusteioDireto]}/>
                                        </FormGroup>
                                    </Col>
                                    <Col xs={12} md={6} lg={4}>
                                        <FormGroup>
                                            <Label>Risco da justificativa/alocação</Label>
                                            <Input type="text"
                                                   value={_.get(this.controller.solicitacao, "justificativaContratacao.classificacaoRisco", "")}
                                                   readOnly/>
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col xs={12} md={6} lg={12}>
                                        <FormGroup>
                                            <Label>Fato gerador</Label>
                                            <Select value={this.controller.solicitacao.fatoGeradorId}
                                                    disabled={fatoGeradorOptions.length === 0 || !this.controller.solicitacao.justificativaContratacaoId}
                                                    isLoading={fatoGeradorOptions.length > 0 && _.get(this.controller.solicitacao, "justificativaContratacao.justificativaAlocavel") === "SIM"}
                                                    options={fatoGeradorOptions}
                                                    autoload={false}
                                                    onChange={(value) => this.controller.setFatoGerador(value)}
                                                    searchPromptText="Informe dados do projeto, centro de resultado ou finalidade para pesquisar"
                                                    noResultsText="Nenhum resultado encontrado"
                                                    placeholder="Selecione..."
                                                    multi={false}/>
                                        </FormGroup>
                                        <FormGroup>
                                            <Label>Projeto/centro de resultado/finalidade {_.get(this.controller.solicitacao, "justificativaContratacaoId") && _.get(this.controller.solicitacao, "justificativaContratacao.justificativaAlocavel") === "SIM" &&
                                                <sup>*</sup>}</Label>
                                            {this.controller.solicitacao.justificativaContratacao &&
                                                <Select value={this.controller.solicitacao.produto.id || ''}
                                                    disabled={produtoOptions.length === 0 || !this.controller.solicitacao.justificativaContratacaoId}
                                                    isLoading={produtoOptions.length === 0 && _.get(this.controller.solicitacao, "justificativaContratacao.justificativaAlocavel") === "SIM"}
                                                    options={produtoOptions}
                                                    autoload={false}
                                                    onChange={(value) => this.controller.setProduto(value)}
                                                    searchPromptText="Informe dados do projeto, centro de resultado ou finalidade para pesquisar"
                                                    noResultsText="Nenhum resultado encontrado"
                                                    placeholder="Selecione..."
                                                    multi={false}/>
                                            }
                                            {this.controller.solicitacao.justificativaContratacao && this.controller.solicitacao.justificativaContratacao.produtoOracle && !bloqueioJustificativaCusteioDireto &&
                                                <span style={{ color: 'darkorange', display: 'block' }}>{"O custeio mensal ocorrerá exclusivamente nesta chave."}</span>
                                            }
                                            {_.get(this.controller.solicitacao.justificativaContratacao, "justificativaAlocavel") === "SIM" &&
                                            <Validacao id="produto" valor={this.controller.solicitacao.produto.id}
                                                       tipo={["isRequired"]}/>
                                            }
                                        </FormGroup>
                                    </Col>
                                    <Col xs={12} lg={12}>
                                        <FormGroup>
                                            <Label>Detalhamento da justificativa/alocação</Label>
                                            <Input type="textarea" maxLength={1024}
                                                   value={this.controller.solicitacao.detalhamentoJustificativa}
                                                   onChange={(event) => this.controller.setDetalhamentoJustificativa(event.target.value)}/>
                                        </FormGroup>
                                    </Col>
                                </Row>
                                {(this.controller.solicitacao.motivoContratacao === "SUB" && this.controller.solicitacao.justificativaContratacaoId !== "") ?
                                    <EmpregadosSubstituidosForm
                                        filtrarEmpregados={(...props) => this.controller.filtrarEmpregados(...props)}
                                        matriculaEmpregadosSubstituidos={this.controller.solicitacao.matriculaEmpregadosSubstituidos}
                                        solicitacaoExcecao={this.controller.solicitacao.solicitacaoExcecao}
                                        adicionarEmpregadoSubstituido={(...props) => this.controller.adicionarEmpregadoSubstituido(...props)}
                                        removerEmpregadoSubstituido={(...props) => this.controller.removerEmpregadoSubstituido(...props)}
                                        setMatriculaEmpregadosSubstituidos={(...props) => this.controller.setMatriculaEmpregadosSubstituidos(...props)}
                                        empregadosSubstituidosMin={this.controller.solicitacao.justificativaContratacao.funcionariosSubstituidosMin}
                                        empregadosSubstituidosMax={this.controller.solicitacao.justificativaContratacao.funcionariosSubstituidosMax}
                                        controller={this.controller}
                                    /> : <div/>
                                }
                                <h4>Prazos e quantidade</h4>
                                <Row>
                                    <Col xs={12} md={6} lg={4}>
                                        <FormGroup>
                                            <Label>Data de início <sup>*</sup></Label>
                                            <DatePicker
                                                ref="dataInicio"
                                                onClickOutside={() => {
                                                    this.refs.dataInicio.cancelFocusInput();
                                                    this.refs.dataInicio.setOpen(false);
                                                }}
                                                disabled={!this.controller.solicitacao.justificativaContratacaoId}
                                                locale={"pt_BR"}
                                                className="form-control"
                                                dateFormat="DD/MM/YYYY"
                                                selectsStart
                                                selected={this.controller.solicitacao.momentDataInicio}
                                                minDate={!this.loginStore.isPerfilAdministradorLogado ? minDate : null}
                                                startDate={this.controller.solicitacao.momentDataInicio}
                                                endDate={this.controller.solicitacao.momentDataTermino}
                                                onChange={(value) => this.controller.setMomentDataInicio(value)}
                                                onBlur={(e) => this.controller.setDataInicioCheck(e.target.value)}/>
                                            {!this.loginStore.isPerfilAdministradorLogado &&
                                                <Validacao id="dataInicio" valor={this.controller.dataInicioValidacao} tipo={["isRequired", "isDate", "SolicDiasMin", curtoIniSolicDiasMin, hoje]}/>
                                            }
                                            {this.loginStore.isPerfilAdministradorLogado && <Validacao id="dataInicio" valor={this.controller.dataInicioValidacao} tipo={["isRequired", "isDate"]}/>}
                                            {msgPrazoRegulamentado}
                                        </FormGroup>
                                    </Col>
                                    <Col xs={12} md={6} lg={4}>
                                        <FormGroup>
                                            <Label for="dataFinal">Data de término <sup>*</sup></Label>
                                            <DatePicker
                                                ref="dataFim"
                                                onClickOutside={() => {
                                                    this.refs.dataFim.cancelFocusInput();
                                                    this.refs.dataFim.setOpen(false);
                                                }}
                                                disabled={!this.controller.solicitacao.justificativaContratacaoId}
                                                locale={"pt_BR"}
                                                className="form-control"
                                                dateFormat="DD/MM/YYYY"
                                                selectsEnd
                                                selected={this.controller.solicitacao.momentDataTermino}
                                                minDate={this.controller.solicitacao.momentDataInicio && solicContratacaoDiasMin ? moment(this.controller.solicitacao.momentDataInicio).add(solicContratacaoDiasMin - 1, "days") : ""}
                                                maxDate={this.controller.solicitacao.momentDataInicio && solicContratacaoDiasMax ? moment(this.controller.solicitacao.momentDataInicio).add(solicContratacaoDiasMax - 1, "days") : ""}
                                                startDate={this.controller.solicitacao.momentDataInicio}
                                                endDate={this.controller.solicitacao.momentDataTermino}
                                                onChange={(value) => this.controller.setMomentDataTermino(value)}
                                                onBlur={(e) => this.controller.setDataTerminoCheck(e.target.value)}/>
                                            <Validacao id="dataTermino" valor={this.controller.dataTerminoValidacao}
                                                       tipo={["isRequired", "isDate", "endDateAfter", this.controller.dataInicioValidacao,
                                                           "SolicDiasMin", solicContratacaoDiasMin - 1, this.controller.dataInicioValidacao,
                                                           "SolicDiasMax", solicContratacaoDiasMax - 1, this.controller.dataInicioValidacao]}/>

                                        </FormGroup>
                                    </Col>
                                    <Col xs={12} md={6} lg={4}>
                                        <FormGroup>
                                            <Label>Quantidade dias</Label>
                                            <Input type="number" value={this.controller.quantidadeDias} readOnly/>
                                        </FormGroup>
                                    </Col>
                                    {!this.controller.solicitacao.solicitacaoExcecao && (
                                        <Col xs={12} md={6} lg={4}>
                                            <FormGroup>
                                                <Label>Quantidade MOT <sup>*</sup></Label>
                                                <Input className="incrementer" type="number"
                                                       value={this.controller.solicitacao.quantidadeRecursos}
                                                       onChange={(event) => this.controller.setQuantidadeRecursos(event.target.value)}
                                                />
                                                <Validacao id="quantidadeRecursos"
                                                           valor={this.controller.solicitacao.quantidadeRecursos}
                                                           tipo={["isRequired", "quantidadeMin", _.get(this.controller.solicitacao, "justificativaContratacao.recursosSolicMotMin"), "quantidadeMax", _.get(this.controller.solicitacao, "justificativaContratacao.recursosSolicMotMax")]}/>
                                            </FormGroup>
                                        </Col>
                                    )}
                                </Row>
                                <CargoForm controller={this.controller}/>
                                <h4>Perfil</h4>
                                <Row>
                                    <Col xs={12} md={12}>
                                        <FormGroup>
                                            <Label>Detalhamento do perfil esperado</Label>
                                            <Input type="textarea" value={this.controller.solicitacao.perfilRecurso}
                                                   maxLength={512}
                                                   onChange={(event) => this.controller.setPerfilRecurso(event.target.value)}/>
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col xs={12} md={6} lg={6}>
                                        <FormGroup>
                                            <Label>
                                                Login/Equipamento Corporativo
                                                <TooltipIcon textKey="solicitacaoContratacao.novaSolicitacao" />
                                            </Label>
                                            <Select value={this.controller.tipoEmailContratacao || ''}
                                                options={tipoEmailContratacaoOptions}
                                                onChange={(value) => this.controller.setTipoEmailContratacao(value)}
                                                placeholder="Selecione..."
                                                multi={false}/>
                                            {/*<Validacao id="tipoEmailContratacao"
                                                valor={this.controller.tipoEmailContratacao}
                                                tipo={["isRequired"]}/> */}
                                        </FormGroup>
                                    </Col>
                                    <Col xs={12} md={12}>
                                        <FormGroup>
                                            <Label>Detalhamento</Label>
                                            <Input type="textarea"
                                                   value={textoTipoEmailContratacao}
                                                   readOnly/>
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <IndicacoesForm
                                    indicacoes={this.controller.solicitacao.indicacoes}
                                    solicitacaoExcecao={this.controller.solicitacao.solicitacaoExcecao}
                                    setCpf={(...props) => this.controller.setIndicacaoCpf(...props)}
                                    setEmail={(...props) => this.controller.setIndicacaoEmail(...props)}
                                    setETTId={(...props) => this.controller.setIndicacaoETTId(...props)}
                                    setNome={(...props) => this.controller.setIndicacaoNome(...props)}
                                    setTelefone={(...props) => this.controller.setIndicacaoTelefone(...props)}
                                    adicionarIndicacao={(...props) => this.controller.adicionarIndicacao(...props)}
                                    removerIndicacao={(...props) => this.controller.removerIndicacao(...props)}
                                    controller={this.controller}
                                />
                                {this.controller.exibeDetalhamentoHistorico &&
                                <DetalhamentoHistoricoFluxo controller={this.controller}/>
                                }
                                <br/>
                                {this.modalForm()}
                                {this.actionToolBar()}
                                {this.formStore.submitted && !this.modalStore.exibirModal.aberto && !this.validacaoStore.isValidForm ? this.error() : ''}
                            </div>
                        </div>
                    </LoadingPanel>
                </div>
            </div>
        )
    }
}